import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { validateAndSaveInsertion } from '../../../redux/thunks/insertionData/insertionData'
import { InitState } from '../../../redux/reducers/root/initialState'
import { useStore } from 'react-redux'
import { logAiTextInvestigation } from '../../../redux/thunks/suggestedText/suggestedTextLogging'

export function useUpdateLocalStateWhenSuggestionsLoaded() {
  const suggestedTextFeature = useAppSelector((state: InitState) => state.suggestedTextFeature)
  const insertionData = useAppSelector((state: InitState) => state.insertionFeature.insertionData)

  const store = useStore<InitState>()
  const dispatch = useAppDispatch()

  useEffect(() => {
    const {
      suggestedTitle,
      suggestedDescription,
      suggestedLocation,
      isLocationManuallyEdited,
      isTitleManuallyEdited,
      isDescriptionManuallyEdited,
    } = suggestedTextFeature

    if (
      (suggestedTitle && suggestedTitle !== insertionData.adTitle) ||
      (suggestedDescription && suggestedDescription !== insertionData.adDescription) ||
      (suggestedLocation && suggestedLocation !== insertionData.adLocation)
    ) {
      const currentInsertionData = store.getState().insertionFeature.insertionData
      const newInsertionData = {
        ...currentInsertionData,
        adTitle: suggestedTitle && !isTitleManuallyEdited ? suggestedTitle : currentInsertionData.adTitle,
        adDescription:
          suggestedDescription && !isDescriptionManuallyEdited
            ? suggestedDescription
            : currentInsertionData.adDescription,
        adLocation:
          suggestedLocation && !isLocationManuallyEdited ? suggestedLocation : currentInsertionData.adLocation,
      }
      const changedFields = {
        adTitle: newInsertionData.adTitle !== currentInsertionData.adTitle,
        adDescription: newInsertionData.adDescription !== currentInsertionData.adDescription,
        adLocation: newInsertionData.adLocation !== currentInsertionData.adLocation,
      }

      if (!changedFields.adTitle && !changedFields.adDescription && !changedFields.adLocation) {
        logAiTextInvestigation('form_apply_skipped_manual_flags', {
          requestId: suggestedTextFeature.lastCompletedRequestId,
          manualFlags: {
            title: isTitleManuallyEdited,
            description: isDescriptionManuallyEdited,
            location: isLocationManuallyEdited,
          },
        })
        return
      }

      dispatch(validateAndSaveInsertion(newInsertionData))
      logAiTextInvestigation('form_apply_success', {
        requestId: suggestedTextFeature.lastCompletedRequestId,
        changedFields,
        manualFlags: {
          title: isTitleManuallyEdited,
          description: isDescriptionManuallyEdited,
          location: isLocationManuallyEdited,
        },
      })
    }
  }, [
    store,
    suggestedTextFeature,
    insertionData.adTitle,
    insertionData.adDescription,
    insertionData.adLocation,
    dispatch,
  ])
}
